// extracted by mini-css-extract-plugin
export default {"logo":"Footer__logo___kkuU4","logoLink":"Footer__logoLink___XXy7x"};